import { render, staticRenderFns } from "./QuestionnaireScoreMatrix.vue?vue&type=template&id=1c1d6a0e&"
import script from "./QuestionnaireScoreMatrix.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireScoreMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
